sap.ui.requireSync("sap/ui/debug/DebugEnv");
